export const TitleService = () => ({

	update(pageName) {
		document.title = `Howick Weather | ${pageName}`;
	}

})
;



// WEBPACK FOOTER //
// ./utils/title-service.js